import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';
import { appConfig } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppSettings {

	// ReSharper disable once InconsistentNaming
	static Spinner = class {
		static SHOW = true;
		static HIDE = false;
	};

	// ReSharper disable once InconsistentNaming
	static MenuOrientation = class {
		static HORIZONTAL = 'horizontal';
		static VERTICAL = 'vertical';
	};

	// ReSharper disable once InconsistentNaming
	static MenuType = class {
		static DEFAULT = 'default';
		static COMPACT = 'compact';
		static MINI = 'mini';
	};

	// ReSharper disable once InconsistentNaming
	static Theme = class {
		static INDIGO_LIGHT = 'indigo-light';
		static TEAL_LIGHT = 'teal-light';
		static RED_LIGHT = 'red-light';
		static GRAY_LIGHT = 'gray-light';
		static BLUE_DARK = 'blue-dark';
		static GREEN_DARK = 'green-dark';
		static PINK_DARK = 'pink-dark';
		static GRAY_DARK = 'gray-dark';
	};

	// ReSharper disable once InconsistentNaming
	static TextDirection = class {
		static RTL = true;
		static LTR = false;
	};
	settings = new Settings(
		appConfig.applicationName,   // theme name
		false,       // loadingSpinner
		true,      // fixedHeader
		true,      // fixedSidenav
		false,      // fixedSidenavUserContent
		false,      // fixedFooter
		false,       // sidenavIsOpened
		false,       // sidenavIsPinned
		'horizontal', // horizontal , vertical
		'default',  // default, compact, mini
		AppSettings.Theme.TEAL_LIGHT,   // indigo-light, teal-light, red-light, gray-light, blue-dark, green-dark, pink-dark, gray-dark
		false       // true = rtl, false = ltr
	);
}
